import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Breadcrumb,
  DatePicker,
  Dropdown,
  Select,
  Upload,
  Typography,
  InputNumber,
  Checkbox,
  Table,
  Radio,
  Modal,
  Popconfirm,
  Tooltip,
  Tag,
} from "antd";
import {
  DoubleRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileAddOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  LinkOutlined,
  PaperClipOutlined,
  EditFilled,
  EditOutlined,
  PhoneOutlined,
  MailOutlined,
  EyeFilled,
  CheckCircleFilled,
  InfoCircleOutlined,
  InfoCircleFilled,
  DownCircleOutlined,
  FileFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addEstimateAPI,
  GetClientByIdApi,
  getEstimateByIdAPI,
  SendEmailForQuoteAcceptance,
  previewEstimateAPI,
  GetPartnerClientByIdApi,
  GetClientsByPartnerClientId,
} from "../ClientsApi";
import { useForm } from "antd/es/form/Form";
import QuoteTypesEnum from "features/Enums/QuoteTypesEnum";
import ServiceIntervalEnum from "features/Enums/ServiceIntervalEnum";
import { getProductsServicesAPI } from "features/ProductsandServices/ProductsandServicesAPI";
import {
  getSalesTaxAPI,
  getStatusAPI,
  GetLookupListApi,
  getQuoteTypeAPI,
  getServiceIntervalAPI,
  getEmployeeAPI,
  getCompanyListAPI,
  getcompaniesAPI,
  getEmployeesAPI,
  getAddressProvincesAPI,
  getAddressCountriesAPI,
  getAddressListAPI,
  GetPartnerSubClientsApi,
} from "CommonComponents/Lookup/LookupAPI";
import { render } from "@testing-library/react";
import { FormattedMessage, useIntl } from "react-intl";
import DiscountTypeEnum from "features/Enums/DiscountTypeEnum";
import StatusEnum from "features/Enums/StatusEnum";
import Address from "CommonComponents/Address";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
import ProductServiceTable from "./ProductServiceTable";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import {
  getAttachments,
  uploadAttachment,
} from "CommonComponents/Attachments/AttachmentsAPI";
import QuoteAddress from "./QuoteAddress";
import SendEmailModal from "./SendEmailModal";
import {
  addFile,
  resetAttachments,
  setAttachments,
} from "CommonComponents/Attachments/AttachmentsSlice";
import AddressType from "features/Enums/AddressType";
import { GetLeadByIdApi } from "features/Leads/LeadsAPI";
import { resetPartnerSubClients } from "CommonComponents/Lookup/LookupSlice";
import LeadFile from "features/Leads/LeadFile/LeadFile";

function AddEstimate() {
  const { TextArea } = Input;
  const { Dragger } = Upload;
  const dateFormat = "DD/MM/YYYY";
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadId } = location?.state || {};
  const { Column } = Table;
  const intl = useIntl();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const quoteTypeId = Form.useWatch("quoteTypeId", form);
  const serviceIntervalId = Form.useWatch("serviceIntervalId", form);
  const { clientId, estimateId, partnerId, projectId } = useParams();
  const companyId = localStorage.getItem("CompanyId");
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "Quotations"
  )?.id;
  const attachmentsFromFiles = useSelector(
    (state) => state.Attachments.attachments
  );
  const fileTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadFiles"
  )?.id;
  useEffect(() => {
    if (leadId && fileTypeId) {
      dispatch(getAttachments(leadId, fileTypeId));
    }

    const leadFilesGroup = attachmentsFromFiles?.[fileTypeId]?.[leadId];

    if (
      fileTypeId === FormType.LeadFiles?.id &&
      leadFilesGroup &&
      !attachmentsFromFiles?.[formTypeId]?.[estimateId] &&
      Array.isArray(leadFilesGroup.documents) &&
      leadFilesGroup.documents.length > 0 &&
      formTypeId
    ) {
      const documents = leadFilesGroup.documents.filter(
        (doc) => !doc.isThumbnail
      );

      const mapped = documents.map((doc, i) => ({
        uid: doc.guidFileName || `existing-${i}`,
        name: doc.originalFileName || `file-${i + 1}`,
        status: "done",
        url: `data:application/octet-stream;base64,${doc.base64Content}`,
        isExisting: true,
        id: doc.id,
      }));

      const quotationStructure = {
        [formTypeId]: {
          [estimateId]: {
            documents: leadFilesGroup.documents,
            formId: estimateId,
            formTypeId: formTypeId,
          },
        },
      };

      dispatch(setAttachments(quotationStructure));

      mapped.forEach((file, index) => {
        dispatch(
          addFile({
            fileName: file.name,
            base64: documents[index]?.base64Content,
            identifier: formTypeId,
            id: null,
          })
        );
      });

      setFileList(mapped);
    }
  }, [
    leadId,
    estimateId,
    fileTypeId,
    formTypeId,
    attachmentsFromFiles,
    dispatch,
  ]);

  const hostURL = process.env.REACT_APP_HOST_URL;
  const token = localStorage.getItem("token_bearer");
  //const [client, setClient] = useState(null);
  const clients = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const ClientsList = useSelector((state) => state.clients.clientsList);
  const partnerSubClients = useSelector(
    (state) => state.lookup.partnerSubClients
  );
  const addressList = useSelector((state) => state.lookup.addressList);
  const estimatesList = useSelector((state) => state.clients.estimatesList);
  const taxList = useSelector((state) => state.lookup.salesTaxList);
  const estimateDetails = useSelector((state) => state.clients.estimateById);
  const companyName = useSelector((state) => state.lookup.companies);
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const leadById = useSelector((state) => state.leads.leadRecordById);
  const quoteTypes = useSelector((state) => state.lookup.quoteTypes);
  const intervals = useSelector((state) => state.lookup.intervals);
  const employeeList = useSelector((state) => state.lookup.employeesList);
  const estimateAttachments = useSelector(
    (state) => state.clients.estimateAttachments
  );
  const [selectedProductss, setSelectedProductss] = useState([
    {
      key: 1,
      productId: null,
      name: "",
      description: "",
      quantity: 1,
      unitPrice: null,
      discount: 0,
      tax: null,
    },
  ]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [formInitialvalues, setFormInitialvalues] = useState();
  const [discount, setDiscount] = useState(0);
  const [selectedTax, setSelectedTax] = useState(null);
  const [isUploadRequired, setIsUploadRequired] = useState(false);
  const [discountType, setDiscountType] = useState(1);
  const [formattedSubTotal, setFormattedSubTotal] = useState("0.00");
  const [formattedGrandTotal, setFormattedGrandTotal] = useState("0.00");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [valueAddress, setValueAddress] = useState(1);
  const [estimateDate, setEstimateDate] = useState(dayjs());
  const [selectedTaxId, setSelectedTaxId] = useState(null);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressType, setAddressType] = useState("");
  //const [selectedAddressType, setSelectedAddressType] = useState(); // This holds 1, 2, or 3
  const [selectedBillingId, setSelectedBillingId] = useState(null);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [depositAmount, setDepositAmount] = useState(0);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalBillOpen, setIsModalBillOpen] = useState(false);
  const [selectedPartnerClientId, setSelectedPartnerClientId] = useState(null);
  const [isPartnerScreen, setIsPartnerScreen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const toggleExpanded = () => setExpanded((prev) => !prev);
  const [isLeadFileOpen, setIsLeadFileOpen] = useState(false);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const onChange = (e) => {
    setValueAddress(e.target.value);
  };
  const handleViewPdf = async () => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (estimateInfo?.EstimateItems?.length > 0) {
        await Promise.all([
          dispatch(previewEstimateAPI(estimateInfo)).then((res) => {
            const base64 = res?.value?.pdfBase64;
            const name = "Quote_Preview";

            if (base64) {
              const pdfWindow = window.open("", "_blank");
              const pdfContent = `data:application/pdf;base64,${base64}`;

              if (pdfWindow) {
                pdfWindow.document.write(`
                <html>
                  <head><title>${name}.pdf</title></head>
                  <body style="margin:0">
                    <iframe width="100%" height="100%" src="${pdfContent}" frameborder="0"></iframe>
                  </body>
                </html>
              `);
                pdfWindow.document.close();
              }
            } else {
              OpenNotificationWithIcon(
                "Error",
                "Common.Error",
                "",
                "AddEstimate.FailedToGeneratePDFPreview"
              );
            }
          }),
        ]);
      } else {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.PleaseAddAlteast1Item"
        );
      }
    } catch (error) {
      console.error("Failed to preview PDF:", error);
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        error.message || "AddEstimate.UnableToPreviewPDF"
      );
    }
  };
  const showModal = () => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${estimateDetails?.id}/editestimate`
        : clientId
        ? `/${companyId}/${clientId}/client_details/${estimateDetails?.id}/editestimate`
        : `/${companyId}/${partnerId}/partner_client_details/${estimateDetails?.id}/editestimate`
    );
    //setIsModalOpen(true);
  };
  const showModal2 = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => setIsModalOpen(false);
  const isQuillContentEmpty = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent.trim() === "";
  };
  const showModal1 = () => {
    setIsModalOpen1(true);
  };
  const handleCancel1 = () => setIsModalOpen1(false);
  const showBillModal = () => {
    setIsModalBillOpen(true);
  };
  const handleBillOk = () => {
    setIsModalBillOpen(false);
  };
  const handleBillCancel = () => {
    setIsModalBillOpen(false);
  };
  const openAddressModal = (type) => {
    setAddressType(type); // 'billing' or 'shipping'
    setIsAddressModalOpen(true);
  };

  const handleAddressCancel = () => {
    setIsAddressModalOpen(false);
    setAddressType("");
  };
  const selectedCompany = companyName?.items?.find(
    (company) => company?.id === parseInt(companyId)
  );

  const input = {
    pageNo: null,
    pageSize: null,
    searchQuery: "",
  };
  const statusMap = {
    1: { text: "Draft", textFr: "Brouillon", color: "gold" },
    2: { text: "Submitted", textFr: "Soumis", color: "blue" },
    3: { text: "Accepted", textFr: "Accepté", color: "green" },
    4: { text: "Rejected", textFr: "Rejeté", color: "red" },
  };
  useEffect(() => {
    if (estimateDetails?.expiryDate) {
      const expiryDate = dayjs(estimateDetails.expiryDate);
      const today = dayjs();

      if (
        estimateDetails?.estimateStatusId === StatusEnum.Draft?.id ||
        estimateDetails?.estimateStatusId === StatusEnum.Submitted?.id
      ) {
        setIsExpired(today.isAfter(expiryDate, "day"));
      } else {
        setIsExpired(false);
      }
    }
  }, [estimateDetails?.expiryDate, estimateDetails?.estimateStatusId]);
  useEffect(() => {
    //dispatch(getProductsServicesAPI(input));
    dispatch(GetLookupListApi(LookupTypeEnum?.CompanyService?.id, input));
    dispatch(getQuoteTypeAPI());
    dispatch(getServiceIntervalAPI());
    dispatch(getEmployeesAPI());
    dispatch(getCompanyListAPI(input));
    dispatch(getStatusAPI());
    dispatch(getSalesTaxAPI());
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
    if (leadId) {
      dispatch(GetLeadByIdApi(leadId));
    }
  }, []);

  useEffect(() => {
    if (clientId && partnerId) {
      dispatch(GetClientByIdApi(clientId));
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    } else if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
    if (estimateId) {
      dispatch(getEstimateByIdAPI(estimateId));
    }
  }, [clientId, estimateId, partnerId]);

  useEffect(() => {
    if (clientSearchTerm != "") {
      dispatch(GetPartnerSubClientsApi(partnerId, clientSearchTerm));
    }
    dispatch(resetPartnerSubClients());
  }, [clientSearchTerm]);

  useEffect(() => {
    if (clientId && !partnerId && clients && !estimateDetails) {
      const billing = clients?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      // setSelectedBillingId(billing?.id);
      // setSelectedShippingId(shipping?.id);
      setBillingAddress(billing);
      setShippingAddress(shipping);
      //setClient(clients);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
        //email: clients?.email,
      });
    } else if (!clientId && partnerId && partner && !selectedPartnerClientId) {
      const billing = partner?.address?.find((a) => a.addressType === 2);

      // setSelectedBillingId(billing?.id);
      setBillingAddress(billing);
      if (!estimateDetails) {
        setIsPartnerScreen(true);
      } else {
        setIsPartnerScreen(false);
      }
      // form.setFieldsValue({
      //   //name: clients?.isResidential ? clients?.name : clients?.companyName, Need to update for Partner
      //   // email: partner?.email,
      // });
    }
    if (clientId && partnerId && clients && partner && !estimateDetails) {
      const billing = partner?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      // setSelectedBillingId(billing?.id);
      // setSelectedShippingId(shipping?.id);
      setBillingAddress(billing);
      setShippingAddress(shipping);
      setIsPartnerScreen(false);
      //  setClient(clients);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
        email: clients?.email,
      });
    }
  }, [clients, partner, estimateDetails]);

  useEffect(() => {
    if (selectedPartnerClientId && estimateDetails) {
      const shipping = clients?.address?.find(
        (a) => a.id === estimateDetails?.addressId
      );
      //setSelectedShippingId(shipping?.id);
      if (shipping) {
        setShippingAddress(shipping);
      } else if (
        !shipping &&
        estimateDetails?.clientId != selectedPartnerClientId
      ) {
        const shipping = clients?.address?.find((a) => a.addressType === 1);

        setShippingAddress(shipping);
      } else {
        dispatch(getAddressListAPI([estimateDetails?.addressId]));
      }

      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
        //email: clients?.email,
      });
    } else if (selectedPartnerClientId) {
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      //setSelectedShippingId(shipping?.id);
      setShippingAddress(shipping);
    }
  }, [clients]);

  useEffect(() => {
    if (selectedPartnerClientId) {
      dispatch(GetClientByIdApi(selectedPartnerClientId));
    }
  }, [selectedPartnerClientId]);

  useEffect(() => {
    if (billingAddress) {
      setSelectedBillingId(billingAddress?.id);
      //setBillingAddress(billingAddress);
    }
  }, [billingAddress]);
  useEffect(() => {
    if (shippingAddress) {
      setSelectedShippingId(shippingAddress?.id);
      //setShippingAddress(shippingAddress);
    }
  }, [shippingAddress]);

  useEffect(() => {
    if (addressList) {
      const billing = addressList?.find(
        (addr) => addr.id === estimateDetails?.billingAddressId
      );
      const shipping = addressList?.find(
        (addr) => addr.id === estimateDetails?.addressId
      );

      if (billing) {
        setBillingAddress(billing);
      }

      if (shipping) {
        setShippingAddress(shipping);
      }
    }
  }, [addressList]);

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr.address1,
      addr.address2,
      addr.city,
      provinceName,
      countryName,
      addr.zip,
    ].filter(Boolean);

    return parts.join(", ");
  };

  useEffect(() => {
    if (selectedProductss.length == 0) {
      setDiscount(0);
      setDiscountType(1);
    }
  }, [selectedProductss]);

  const handleTaxChange = (value, option) => {
    if (!value) {
      setSelectedTaxId(null);
      setSelectedTaxPercentage(null);
      setSelectedTax(null);
      return;
    }
    const taxObject = taxList.find((tax) => tax?.id === value);
    if (taxObject) {
      setSelectedTaxId(taxObject?.id);
      setSelectedTaxPercentage(taxObject?.taxPercentage);
      setSelectedTax(taxObject?.taxPercentage);
    }
  };
  const getSubTotal = () => {
    if (estimateDetails && !selectedProductss.length) {
      return estimateDetails.totalCost || 0;
    }
    return selectedProductss.reduce((sum, product) => {
      const amount = Number(product.amount) || 0;
      return sum + amount;
    }, 0);
  };

  const getTaxAmount = () => {
    if (!selectedTaxPercentage) return 0;

    const subTotal = getSubTotal();
    return (subTotal * selectedTaxPercentage) / 100;
  };

  const getGrandTotal = () => {
    if (quoteTypeId === QuoteTypesEnum.Warranty?.id) {
      return 0;
    }
    if (estimateDetails && !selectedProductss.length && !selectedTax) {
      return estimateDetails.grandTotal || 0;
    }
    return getSubTotal() + getTaxAmount();
  };
  useEffect(() => {
    const subTotal = getSubTotal();
    const grandTotal = getGrandTotal();

    setFormattedSubTotal(
      subTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
    setFormattedGrandTotal(
      grandTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }, [selectedProductss, selectedTaxPercentage, selectedTax, quoteTypeId]);

  const constructEstimateObject = async (emailData = null) => {
    try {
      const values = await form.validateFields();

      const estimateObject = {
        Id: estimateId ? estimateDetails?.id : 0,
        CompanyId: companyId,
        ClientId: estimateDetails?.clientId,
        AddressId: estimateDetails?.addressId,
        BillingAddressId: estimateDetails?.billingAddressId,
        EstimateDate: estimateDetails?.estimateDate,
        ExpiryDate: estimateDetails?.expiryDate,
        TotalCost: estimateDetails?.totalCost,
        TotalDiscount: discount,
        TotalTax: estimateDetails?.totalTax,
        TaxId: estimateDetails?.taxId,
        TaxPercentage: selectedTax || 0,
        GrandTotal: estimateDetails?.grandTotal.toFixed(2),
        Notes: estimateDetails?.notes,
        TermsAndConditions: estimateDetails?.termsAndConditions,
        EstimateStatusId: StatusEnum.Draft?.id,
        PONumber: estimateDetails?.ponumber,
        DiscountType: discountType,
        SalesPersonId: estimateDetails?.salesPersonId,
        Deposit: estimateDetails?.depositAmount,
        companyServiceId: estimateDetails?.companyServiceId,
        QuoteTypeId: estimateDetails?.quoteTypeId,
        ServiceIntervalId: estimateDetails?.serviceIntervalId,
        ContractStartDate: estimateDetails?.contractStartDate,
        EndOccurances: estimateDetails?.endOccurances,
        IntervalInMonths: estimateDetails?.intervalInMonths,
        IntervalInYears: estimateDetails?.intervalInYears,
        EstimateItems: estimateDetails?.estimateItems
          //.filter((product) => product.productId)
          .map((product) => ({
            Id: product?.id,
            EstimateId: estimateId ? estimateDetails?.id : 0,
            ProductServiceId: product?.productServiceId,
            Name: product?.productServiceName,
            Quanity: product?.quantity,
            Rate: product.rate,
            Discount: product.discount,
            Amount: product.amount,
            ClassId: null,
          })),
        BillingAddress: selectedBillingId ? null : billingAddress,
        shippingAddress: selectedShippingId ? null : shippingAddress,
        PartnerId: partnerId ? partnerId : null,
      };

      if (emailData) {
        var input = {
          estimate: estimateObject,
        };
        input.Email = {
          EstimateId: estimateId ? estimateDetails?.id : 0,
          EstimateStatusId: StatusEnum.Submitted?.id,
          To: values.email
            ? values.email.split(",").map((e) => e.trim())
            : [""],
          Cc: values.cc ? values.cc.split(",").map((e) => e.trim()) : [""],
          Subject: values.subject || "",
          Message: values.message || "",
          IncludedAttachment: values.includedAttachment ?? true,
        };
        return input;
      }

      return estimateObject;
    } catch (error) {
      console.log("Error in constructing estimate object:", error);
      throw error;
    }
  };
  const handleUpsertEstimate = async (checked) => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (!estimateInfo || estimateInfo.EstimateItems?.length === 0) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      dispatch(addEstimateAPI(estimateInfo, companyId)).then((res) => {
        if (res) {
          dispatch(uploadAttachment(res));
          setSelectedProductss((prev) => prev.filter((item) => item.productId));

          setIsUploadRequired(checked);
          const url =
            partnerId && clientId
              ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
              : clientId
              ? `/${companyId}/${clientId}/client_details`
              : `/${companyId}/${partnerId}/partner_client_details`;

          navigate(url);
          setSelectedPartnerClientId(null);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitQuoteAndSendEmail = async (emailData) => {
    try {
      await form.validateFields();
      const estimateInfo = await constructEstimateObject(emailData);
      const { estimate, ...inputWithoutEstimate } = estimateInfo;
      estimateInfo.estimate.EstimateStatusId = StatusEnum.Submitted?.id;
      dispatch(addEstimateAPI(estimateInfo?.estimate, companyId)).then(
        async (res) => {
          if (res) {
            await dispatch(uploadAttachment(res));
            inputWithoutEstimate.Email.EstimateId = res;
            dispatch(SendEmailForQuoteAcceptance(inputWithoutEstimate.Email));
            const url =
              partnerId && clientId
                ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                : clientId
                ? `/${companyId}/${clientId}/client_details`
                : `/${companyId}/${partnerId}/partner_client_details`;

            navigate(url);
            setSelectedPartnerClientId(null);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  const handleDownloadPdf = async () => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (estimateInfo?.EstimateItems?.length > 0) {
        await dispatch(previewEstimateAPI(estimateInfo)).then((res) => {
          const base64 = res?.value?.pdfBase64;
          const name = `Quote_${estimateDetails?.estimateNo || "Download"}`;

          if (base64) {
            const link = document.createElement("a");
            link.href = `data:application/pdf;base64,${base64}`;
            link.download = `${name}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            OpenNotificationWithIcon(
              "Error",
              "Common.Error",
              "",
              "AddEstimate.FailedToGeneratePDF"
            );
          }
        });
      }
    } catch (error) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        error.message || "AddEstimate.UnableToDownloadPDF"
      );
    }
  };
  const totalColumns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return {
            children: text,
            props: { colSpan: 2 },
          };
        }
        return text;
      },
    },
    {
      title: "discountinput",
      dataIndex: "discountinput",
      key: "discountinput",
      width: 190,
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return { children: null, props: { colSpan: 0 } };
        }

        // if (record.key === "2") {
        //   const discountSuffix =
        //     discountType === 1 ? "%" : ` ($${discount?.toFixed(2) || "0.00"})`;

        //   return (
        //     <p style={{ marginBottom: 0 }}>
        //       {discount || 0}
        //       {discountSuffix}
        //     </p>
        //   );
        // }

        if (record.key === "3") {
          const selectedTaxItem = taxList?.find((t) => t.id === selectedTaxId);
          return (
            <p style={{ marginBottom: 0 }}>
              {selectedTaxItem
                ? `${selectedTaxItem.name} ${selectedTaxItem.taxPercentage}%`
                : "-"}
            </p>
          );
        }

        return text;
      },
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "right",
      width: 130,
    },
  ];

  const data = [
    {
      key: "1",
      description: <FormattedMessage id="AddEstimate.SubTotal" />,
      value: `$${estimateDetails?.totalCost}`,
    },
    {
      key: "2",
      description: <FormattedMessage id="Quote.Discount" />,
      value: estimateDetails?.totalDiscount
        ? estimateDetails?.discountType === 1
          ? `${estimateDetails?.totalDiscount}%`
          : `$${estimateDetails?.totalDiscount.toFixed(2)}`
        : "$0.00",
    },
    {
      key: "3",
      description: <FormattedMessage id="AddEstimate.TotalTax" />,
      value: selectedTax ? `$${estimateDetails?.totalTax.toFixed(2)}` : "$0.00",
    },
    {
      key: "4",
      description: <FormattedMessage id="AddEstimate.GrandTotal" />,
      value: `$${estimateDetails?.grandTotal}`,
      className: "total-row",
    },
    {
      key: "5",
      description: (
        <div>
          <FormattedMessage id="Quote.DepositAmount" />
        </div>
      ),
      value: `${
        estimateDetails?.depositType
          ? `${depositAmount || 0}%`
          : `$${(depositAmount || 0).toFixed(2)}`
      }`,
    },
  ];

  useEffect(() => {
    if (estimateDetails) {
      const estimateDate = estimateDetails?.estimateDate
        ? dayjs(estimateDetails?.estimateDate, "YYYY-MM-DD")
        : null;
      const expiryDate = estimateDetails?.expiryDate
        ? dayjs(estimateDetails?.expiryDate, "YYYY-MM-DD")
        : null;
      const contractStartDate = estimateDetails?.contractStartDate
        ? dayjs(estimateDetails?.contractStartDate, "YYYY-MM-DD")
        : null;
      const addressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.addressId
      );
      const billingAddressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.billingAddressId
      );
      const taxObject = taxList?.find(
        (tax) => tax.id === estimateDetails?.taxId
      );
      if (taxObject) {
        setSelectedTaxId(taxObject?.id);
        setSelectedTaxPercentage(taxObject?.taxPercentage);
        setSelectedTax(taxObject?.taxPercentage);
      } else if (estimateDetails.taxPercentage) {
        setSelectedTaxId(estimateDetails?.taxId);
        setSelectedTaxPercentage(estimateDetails?.taxPercentage);
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails.taxPercentage) {
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails.deposit) {
        setDepositAmount(estimateDetails.deposit);
      }
      setFormattedSubTotal(
        estimateDetails.totalCost.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      setFormattedGrandTotal(
        estimateDetails.grandTotal.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
      const missingAddressIds = [];

      if (partner) {
        const billingAddress = partner?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );
        setBillingAddress(billingAddress);
        setSelectedPartnerClientId(estimateDetails?.clientId);
      } else {
        const billingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );

        const shippingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.addressId
        );
        if (billingAddress) {
          setBillingAddress(billingAddress);
        } else {
          missingAddressIds.push(estimateDetails.billingAddressId);
        }

        if (shippingAddress) {
          setShippingAddress(shippingAddress);
        } else {
          missingAddressIds.push(estimateDetails.addressId);
        }

        if (!billingAddress || !shippingAddress) {
          dispatch(getAddressListAPI(missingAddressIds));
        }
      }

      form.setFieldsValue({
        ...estimateDetails,
        estimateDate,
        expiryDate,
        contractStartDate,
        status: estimateDetails?.estimateStatusId,
        addressId: addressIdExists ? estimateDetails?.addressId : null,
        billingAddressId: billingAddressIdExists
          ? estimateDetails?.billingAddressId
          : null,
        deposit: estimateDetails.deposit,
        taxPercentage: estimateDetails.taxPercentage,
      });

      setDiscount(estimateDetails?.totalDiscount);
      setDiscountType(estimateDetails?.discountType || 1);
      setSelectedTax(estimateDetails?.totalTax);
      const filesAvailable = estimateAttachments?.length > 0;
      if (filesAvailable) {
        setIsUploadRequired(true);
      }
      if (estimateDetails?.estimateItems) {
        const initialProducts = estimateDetails?.estimateItems.map((item) => ({
          key: item.id,
          productServiceId: item.productServiceId,
          name: item.productServiceName,
          description: item.description,
          quantity: item.quantity,
          unitPrice: item.rate,
          discount: item.discount,
          amount: item.amount,
        }));
        setSelectedProducts(initialProducts);
      }
    }
  }, [estimateDetails, form]);
  useEffect(() => {
    if (selectedCompany?.termsAndConditions) {
      form.setFieldsValue({
        termsAndConditions: selectedCompany.termsAndConditions,
      });
    }
    if (estimateDate) {
      const expiry = estimateDate.clone().add(1, "month");
      form.setFieldsValue({ expiryDate: expiry });
    }
    if (leadId && leadById) {
      form.setFieldsValue({
        companyServiceId: leadById.companyServiceId,
      });
    }
    if (
      leadById &&
      employeeList?.some((emp) => emp.id === leadById.responsibleId)
    ) {
      form.setFieldsValue({
        salesPersonId: leadById.responsibleId,
      });
    }
  }, [selectedCompany, estimateDate, leadById, employeeList, form]);
  useEffect(() => {
    if (quoteTypeId === 3) {
      setFormattedGrandTotal("0.00");
    } else if (quoteTypeId === 4) {
      if (formattedGrandTotal === "0.00") {
        const subTotal = getSubTotal();
        const grandTotal =
          subTotal + (subTotal * (selectedTaxPercentage || 0)) / 100;
        setFormattedGrandTotal(
          grandTotal.toLocaleString("en-CA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    }
  }, [quoteTypeId, getSubTotal]);

  const resetFormAndState = () => {
    form.resetFields();
    form.setFieldsValue({
      estimateDate: dayjs(),
      contractStartDate: dayjs(),
    });
    setEstimateDate(dayjs());
    setSelectedProducts([]);
    setDiscount(0);
    setDiscountType(1);
    setSelectedTax(null);
    setSelectedTaxId(null);
    setSelectedTaxPercentage(null);
    setFormattedSubTotal("0.00");
    setFormattedGrandTotal("0.00");
    setDepositAmount(0);
    setFileList([]);
    setIsUploadRequired(false);
  };
  useEffect(() => {
    if (!estimateId) {
      resetFormAndState();
    }
  }, [estimateId, form]);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const items = [
    {
      key: "1",
      label: (
        <Space direction="vertical">
          <div className="f-12">
            <PhoneOutlined />
            &nbsp;&nbsp;
            {employeeList?.find(
              (emp) => emp?.id === form.getFieldValue("salesPersonId")
            )?.phone || "--"}
          </div>
          <div className="f-12">
            <MailOutlined />
            &nbsp;&nbsp;
            {employeeList?.find(
              (emp) => emp?.id === form.getFieldValue("salesPersonId")
            )?.email || "--"}
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
              {/* Left section — Quote title */}
              <Col xs={24} md={18} lg={12}>
                <h4>
                  <FormattedMessage id="ViewQuote.ViewQuote" /> (
                  {estimateDetails?.estimateNo})
                  <span
                    style={{
                      color: estimateDetails?.isExpired
                        ? "red"
                        : statusMap[estimateDetails?.estimateStatusId]?.color,
                      marginLeft: 8,
                    }}
                  >
                    <Tag
                      color={
                        estimateDetails?.isExpired
                          ? "red"
                          : statusMap[estimateDetails?.estimateStatusId]?.color
                      }
                    >
                      {estimateDetails?.isExpired
                        ? selectedLanguage === "fr-FR"
                          ? "Expiré"
                          : "Expired"
                        : selectedLanguage === "fr-FR"
                        ? statusMap[estimateDetails?.estimateStatusId]?.textFr
                        : statusMap[estimateDetails?.estimateStatusId]?.text}
                    </Tag>
                  </span>
                </h4>
                <p className="mt-5px">View, edit or manage your Sales Quote.</p>
              </Col>

              {/* Right section — Breadcrumbs */}
              <Col
                xs={24}
                md={6}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  textAlign: "right",
                }}
              >
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: (
                        <FormattedMessage
                          id={
                            partnerId
                              ? "PartnerCLient.Partners"
                              : "ClientDetails.Clients"
                          }
                        />
                      ),
                      href: partnerId
                        ? `/${companyId}/partner`
                        : `/${companyId}/clients`,
                    },
                    {
                      title: (
                        <FormattedMessage
                          id={
                            partnerId
                              ? "PartnerClient.PartnerClientDetails"
                              : "ClientDetails.ClientDetails"
                          }
                        />
                      ),
                      href: clientId
                        ? `/${companyId}/${clientId}/client_details`
                        : `/${companyId}/${partnerId}/partner_client_details`,
                    },
                    partnerId &&
                      clientId && {
                        title: (
                          <FormattedMessage id="ClientDetails.ClientDetails" />
                        ),
                        href: `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${projectId}`,
                      },
                    {
                      title: <FormattedMessage id="Leads.ViewQuote" />,
                    },
                  ].filter(Boolean)}
                />
              </Col>
            </Row>
          </div>
          <Row gutter={[16, 16]} className="viewquote-new addestimate">
            <Col xs={24} md={24} lg={18}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={formInitialvalues}
                autoComplete="off"
                size="large"
                className="addestimate"
              >
                <Card bordered={false}>
                  <Row gutter={[16, 4]}>
                    <Col span={24}>
                      <Typography.Text strong>
                        To:{" "}
                        <a href="">
                          {" "}
                          {isPartnerScreen
                            ? (partnerSubClients || []).find(
                                (cl) => cl.id === estimateDetails?.clientId
                              )?.[
                                (partnerSubClients.find(
                                  (cl) => cl.id === estimateDetails?.clientId
                                )?.isResidential
                                  ? "nameEn"
                                  : "companyName") || "nameEn"
                              ] || "-"
                            : clients?.isResidential
                            ? clients?.name
                            : clients?.companyName || "-"}
                        </a>
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={5} lg={4}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.BillingAddress" />
                      </Typography.Text>
                      <p>{renderAddress(billingAddress)}</p>
                    </Col>
                    <Col xs={24} sm={5} lg={4}>
                      {shippingAddress ? (
                        <>
                          <Typography.Text strong>
                            <FormattedMessage id="AddEstimate.ShippingAddress" />
                          </Typography.Text>
                          <p>{renderAddress(shippingAddress)}</p>
                        </>
                      ) : null}
                    </Col>
                    <Col xs={12} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.EstimateDate" />
                      </Typography.Text>
                      <p>
                        {estimateDetails?.estimateDate
                          ? dayjs(estimateDetails.estimateDate).format(
                              "YYYY-MM-DD"
                            )
                          : "-"}
                      </p>
                    </Col>

                    <Col xs={12} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.ExpiryDate" />
                      </Typography.Text>
                      <p>
                        {estimateDetails?.expiryDate
                          ? dayjs(estimateDetails.expiryDate).format(
                              "YYYY-MM-DD"
                            )
                          : "-"}
                      </p>
                    </Col>

                    <Col xs={12} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.PONumber" />
                      </Typography.Text>
                      <p>{estimateDetails?.ponumber || "-"}</p>
                    </Col>
                    <Col xs={12} sm={4}>
                      <Typography.Text strong>
                        <FormattedMessage id="Quote.SalesPerson" />
                      </Typography.Text>
                      {(() => {
                        const salesPerson = employeeList?.find(
                          (emp) => emp.id === estimateDetails?.salesPersonId
                        );
                        if (!salesPerson) return <p>-</p>;

                        return (
                          <div>
                            <p>
                              {salesPerson.firstName} {salesPerson.lastName}
                              &nbsp;&nbsp;&nbsp;
                              <Dropdown
                                menu={{ items }}
                                trigger={["click"]}
                                placement="bottom"
                              >
                                <InfoCircleFilled
                                  style={{
                                    color: "#1677ff",
                                    cursor: "pointer",
                                  }}
                                />
                              </Dropdown>
                            </p>
                          </div>
                        );
                      })()}
                    </Col>
                  </Row>
                  <Row gutter={[16, 4]} className="mt-20">
                    <Col xs={12} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="Quote.Services" />
                      </Typography.Text>
                      <p>
                        {companyServices
                          ?.filter((company) => company?.companyId == companyId)
                          ?.find(
                            (company) =>
                              company?.id === estimateDetails?.companyServiceId
                          )?.[
                          `name${selectedLanguage === "fr-FR" ? "Fr" : "En"}`
                        ] || "-"}
                      </p>
                    </Col>

                    <Col xs={12} sm={5}>
                      <Typography.Text strong>
                        <FormattedMessage id="Quote.Type" />
                      </Typography.Text>
                      <p>
                        {quoteTypes?.find(
                          (type) => type?.id === estimateDetails?.quoteTypeId
                        )?.[
                          `name${selectedLanguage === "fr-FR" ? "Fr" : "En"}`
                        ] || "-"}
                      </p>
                    </Col>

                    {estimateDetails?.serviceIntervalId !== null && (
                      <Col xs={12} sm={3}>
                        <Typography.Text strong>
                          <FormattedMessage id="Quote.SetInterval" />
                        </Typography.Text>
                        <p>
                          {intervals?.find(
                            (interval) =>
                              interval?.id ===
                              estimateDetails?.serviceIntervalId
                          )?.[
                            `name${selectedLanguage === "fr-FR" ? "Fr" : "En"}`
                          ] || "-"}
                        </p>
                      </Col>
                    )}

                    {estimateDetails?.contractStartDate !== null && (
                      <Col xs={12} sm={4}>
                        <Typography.Text strong>
                          <FormattedMessage id="Quote.CreateQuote" />
                        </Typography.Text>
                        <p>
                          {estimateDetails?.contractStartDate
                            ? dayjs(estimateDetails.contractStartDate).format(
                                "YYYY-MM-DD"
                              )
                            : "-"}
                        </p>
                      </Col>
                    )}

                    {estimateDetails?.intervalInMonths !== null && (
                      <Col xs={12} sm={4}>
                        <Typography.Text strong>
                          <FormattedMessage id="Quote.IntervalInMonths" />
                        </Typography.Text>
                        <p>{estimateDetails?.intervalInMonths || "-"}</p>
                      </Col>
                    )}

                    {estimateDetails?.intervalInYears !== null && (
                      <Col xs={12} sm={4}>
                        <Typography.Text strong>
                          <FormattedMessage id="Quote.IntervalInYears" />
                        </Typography.Text>
                        <p>{estimateDetails?.intervalInYears || "-"}</p>
                      </Col>
                    )}
                    {estimateDetails?.endOccurances !== null && (
                      <Col xs={12} sm={4}>
                        <Typography.Text strong>
                          <FormattedMessage
                            id="Quote.EndOfOccurrences"
                            values={{
                              interval:
                                serviceIntervalId ===
                                ServiceIntervalEnum.Daily?.id
                                  ? "days"
                                  : serviceIntervalId ===
                                    ServiceIntervalEnum.Weekly?.id
                                  ? "weeks"
                                  : serviceIntervalId ===
                                    ServiceIntervalEnum.Monthly?.id
                                  ? "months"
                                  : "years",
                            }}
                          />
                        </Typography.Text>
                        <p>{estimateDetails?.endOccurances || "-"}</p>
                      </Col>
                    )}
                  </Row>

                  <Table
                    className="mt-20 view-quotemail"
                    dataSource={estimateDetails?.estimateItems || []}
                    pagination={false}
                    bordered
                    scroll={{ x: 900 }}
                    rowKey={(record, index) => index}
                    summary={(pageData) => {
                      const total = pageData.reduce(
                        (sum, item) => sum + (item.amount || 0),
                        0
                      );
                      return (
                        <Table.Summary fixed>
                          <Table.Summary.Row>
                            <Table.Summary.Cell
                              index={0}
                              colSpan={5}
                              className="text-right"
                            >
                              <b>TOTAL</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="right">
                              <b>${total.toFixed(2)}</b>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </Table.Summary>
                      );
                    }}
                  >
                    <Column
                      title={<FormattedMessage id="ViewQuote.Item" />}
                      dataIndex="productServiceName"
                      key="productServiceName"
                    />
                    <Column
                      title={<FormattedMessage id="AddEstimate.Description" />}
                      dataIndex="description"
                      key="description"
                    />
                    <Column
                      title={<FormattedMessage id="ViewQuote.Quantity" />}
                      dataIndex="quantity"
                      key="quantity"
                      align="right"
                    />
                    <Column
                      title={<FormattedMessage id="Quote.UnitPrice" />}
                      dataIndex="rate"
                      key="rate"
                      align="right"
                      render={(value) => `$${value?.toFixed(2) || "0.00"}`}
                    />
                    <Column
                      title={<FormattedMessage id="Quote.Discount" />}
                      dataIndex="discount"
                      key="discount"
                      align="right"
                      render={(value) => `$${value?.toFixed(2) || "0.00"}`}
                    />
                    <Column
                      title={<FormattedMessage id="AddEstimate.Amount" />}
                      dataIndex="amount"
                      key="amount"
                      align="right"
                      render={(value) => `$${value?.toFixed(2) || "0.00"}`}
                    />
                  </Table>
                  <Row gutter={[16, 16]} justify="end" className="mt-20">
                    {/* Notes Section */}
                    <Col
                      xs={{ span: 24, order: 2 }}
                      sm={{ span: 24, order: 2 }}
                      md={{ span: 9, order: 1 }}
                      lg={{ span: 12, order: 1 }}
                    >
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          <Typography.Text strong>
                            <FormattedMessage id="AddEstimate.Notes" />
                          </Typography.Text>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {estimateDetails?.notes || "-"}
                          </p>
                        </Col>
                      </Row>
                    </Col>

                    {/* Table Section */}
                    <Col
                      xs={{ span: 24, order: 1 }}
                      sm={{ span: 24, order: 1 }}
                      md={{ span: 15, order: 2 }}
                      lg={{ span: 12, order: 2 }}
                    >
                      <Table
                        className="view-quotemail"
                        bordered
                        showHeader={false}
                        columns={totalColumns}
                        dataSource={data}
                        pagination={false}
                        rowClassName={(record) =>
                          record.className === "total-row" ? "bold-text" : ""
                        }
                      />
                    </Col>

                    {/* Terms & Conditions */}
                    <Col
                      xs={{ span: 24, order: 3 }}
                      sm={{ span: 24, order: 3 }}
                      className="mt-20"
                    >
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.TermsAndConditions" />
                      </Typography.Text>
                      <div className="quote-quill">
                        {selectedCompany?.termsAndConditions &&
                          !isQuillContentEmpty(
                            selectedCompany.termsAndConditions
                          ) && (
                            <>
                              <div
                                className={`clamped-content ${
                                  expanded ? "expanded" : ""
                                }`}
                                dangerouslySetInnerHTML={{
                                  __html: selectedCompany.termsAndConditions,
                                }}
                              />
                              <span
                                className="toggle-link"
                                onClick={toggleExpanded}
                              >
                                {expanded ? "Read less" : "Read more"}
                              </span>
                            </>
                          )}
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Form>
            </Col>
            <Col xs={24} md={24} lg={6}>
              {partner && (
                <h4>
                  <FormattedMessage id="ClientDetails.PartnerOf" /> &nbsp;
                  {`${partner?.companyName}`}
                </h4>
              )}
              <Card>
                <Row gutter={[8]} className="viewinvoicebuttons">
                  <Col span={12}>
                    <Button
                      color="default"
                      variant="link"
                      block
                      onClick={handleViewPdf}
                    >
                      <EyeFilled />
                      <FormattedMessage id="ViewQuote.Preview" />
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      color="default"
                      variant="link"
                      onClick={() => setIsLeadFileOpen(true)}
                      block
                    >
                      <PaperClipOutlined />
                      <FormattedMessage id="ViewQuote.Files" />
                    </Button>
                  </Col>
                  {!isExpired &&
                    !(
                      estimateDetails?.estimateStatusId ===
                        StatusEnum.Accepted?.id ||
                      estimateDetails?.estimateStatusId ===
                        StatusEnum.Rejected?.id
                    ) && (
                      <Col span={12}>
                        <Button
                          color="default"
                          variant="link"
                          onClick={showModal}
                          block
                        >
                          <EditFilled />
                          <FormattedMessage id="AddEstimate.EditEstimate" />
                        </Button>
                      </Col>
                    )}
                  {!isExpired &&
                    !(
                      estimateDetails?.estimateStatusId ===
                        StatusEnum.Accepted?.id ||
                      estimateDetails?.estimateStatusId ===
                        StatusEnum.Rejected?.id
                    ) && (
                      <Col span={12}>
                        <Button
                          color="default"
                          variant="link"
                          onClick={showModal2}
                          block
                        >
                          <CheckCircleFilled />
                          <FormattedMessage id="ViewQuote.ResendEmail" />
                        </Button>
                      </Col>
                    )}
                  <Col span={12}>
                    <Button
                      color="default"
                      variant="link"
                      onClick={handleDownloadPdf}
                      block
                    >
                      <DownloadOutlined />
                      <FormattedMessage id="ViewQuote.Download" />
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      color="default"
                      variant="link"
                      onClick={() => {
                        let basePath;
                        if (clientId && !partnerId) {
                          basePath = `/${companyId}/${clientId}/client_details/addestimate`;
                        } else if (partnerId && !clientId) {
                          basePath = `/${companyId}/${partnerId}/partner_client_details/addestimate`;
                        } else if (partnerId && clientId) {
                          basePath = `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/addestimate`;
                        } else {
                          basePath = "/";
                        }

                        navigate(basePath, {
                          state: {
                            cloneFrom: estimateDetails.id,
                            // Preserve leadId if it exists
                            ...(leadId && { leadId }),
                          },
                        });
                      }}
                    >
                      <FileFilled />
                      <FormattedMessage id="ViewQuote.Copy" />
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          {isAddressModalOpen && (
            <QuoteAddress
              billingAddress={billingAddress}
              shippingAddress={shippingAddress}
              setBillingAddress={setBillingAddress}
              setShippingAddress={setShippingAddress}
              onCancel={() => setIsAddressModalOpen(false)}
              addressType={addressType}
            />
          )}
          <Modal
            title={<FormattedMessage id="Quote.UploadAttachments" />}
            width={800}
            open={isModalOpen1}
            onCancel={handleCancel1}
            footer={[
              <Button key="ok" type="primary" onClick={handleCancel1}>
                Ok
              </Button>,
            ]}
          >
            <Form form={form} size="large" layout="vertical">
              <Form.Item
                label={<FormattedMessage id="AddEstimate.Attachments" />}
                //name="Attachments"
                valuePropName="fileList"
                getValueFromEvent={(e) =>
                  Array.isArray(e) ? e : e && e.fileList
                }
              >
                <AttachmentComponent
                  identifier={formTypeId}
                  currentId={estimateId}
                  getattachments={true}
                />
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            width={800}
            open={isLeadFileOpen}
            onCancel={() => setIsLeadFileOpen(false)}
            footer={[
              <Button
                key="ok"
                type="primary"
                onClick={() => setIsLeadFileOpen(false)}
              >
                Ok
              </Button>,
            ]}
          >
            <LeadFile currentId={estimateDetails?.id} identifier={formTypeId} />
          </Modal>
          <SendEmailModal
            isOpen={isModalOpen}
            onCancel={handleCancel}
            onSend={handleSubmitQuoteAndSendEmail}
            form={form}
            estimateId={estimateId}
            attachmentsFromFiles={attachmentsFromFiles}
            estimateDetails={estimateDetails}
          />
        </div>
      </div>
    </>
  );
}

export default AddEstimate;
